export default "__VITE_ASSET__DLOtqAb0__"